import type { Locale } from "./en";

// Arabic translations. Missing keys fall back to English via i18next.
export const ar: Locale = {
  common: {
    home: "الرئيسية",
    no_scores: "لا توجد نقاط بعد",
    points_count_one: "{{count}} نقطة",
    points_count_other: "{{count}} نقطة",
    questions_count_one: "{{count}} سؤال",
    questions_count_other: "{{count}} سؤال",
  },
  home: {
    placeholder: "رمز اللعبة",
    enter: "انضم",
    error_invalid_code: "أدخل رمز اللعبة المكوّن من 6 أحرف الذي حصلت عليه من معلّمك.",
    footer: "ابدأ Binogi Buzz من منتجات Binogi.com.",
    language_label: "اللغة",
  },
  errors: {
    generic: "حدث خطأ ما. حاول مرة أخرى.",
    stale_client: "صفحتك قديمة — يرجى تحديثها.",
    session_not_found: "تعذّر العثور على هذه الجلسة.",
    session_not_open: "انتهت هذه الجلسة.",
    session_not_active: "انتهى هذا السؤال أو هذه الجلسة بالفعل.",
    not_teacher: "المعلّم فقط يمكنه فعل ذلك.",
    already_answered: "لقد أجبت عن هذا السؤال بالفعل.",
    wrong_question_index: "لم يبدأ هذا السؤال بعد.",
    name_taken: "هذا الاسم مستخدم بالفعل. جرّب اسمًا آخر.",
    character_busy: "تعذّر منحك شخصية الآن — حاول مرة أخرى.",
  },
  host: {
    input: {
      heading: "ابدأ Buzz",
      lead:
        "أدخل رمز درس Binogi الذي يدرسه طلابك. سنحمّل أسئلته وننشئ جلسة يمكنك عرضها على السبورة.",
      lesson_code_label: "رمز الدرس",
      placeholder_code: "BIH750",
      load_button: "تحميل الدرس",
      try_hint: "جرّب:",
      error_invalid_code: "أدخل رمز درس Binogi، مثل BIH750.",
      error_not_found: "لم يُعثر على درس بالرمز {{code}}.",
      error_unreachable: "تعذّر الوصول إلى خادم الدروس. تحقّق من اتصالك وحاول مرة أخرى.",
      error_no_questions: "لا يحتوي الدرس {{code}} على أسئلة يمكن لـ Buzz استخدامها.",
      error_no_level_questions: "لا يحتوي الدرس {{code}} على أسئلة من المستوى المختار.",
    },
    loading: "جارٍ تحميل الدرس…",
    placeholder_title: "ابدأ Binogi Buzz",
    tab_details: "التفاصيل",
    tab_questions: "الأسئلة",
    settings: "الإعدادات",
    number_of_students: "عدد الطلاب",
    fewer_students: "طلاب أقل",
    more_students: "طلاب أكثر",
    player_names: "أسماء اللاعبين",
    player_anonymous: "مجهول",
    player_self_chosen: "يختارها الطلاب",
    language: "اللغة",
    language_teacher: "يختارها المعلّم",
    language_students: "يختارها الطلاب",
    time_per_question: "الوقت لكل سؤال",
    time_option: "{{seconds}} ث",
    start_button: "ابدأ الجلسة",
    start_disabled: "اختر حجم الصف للبدء",
    creating: "جارٍ إنشاء الجلسة…",
    error_no_questions: "أبقِ على سؤال واحد على الأقل قبل البدء.",
    error_create_failed: "تعذّر إنشاء الجلسة",
    error_load_failed: "تعذّر تحميل الدرس",
    no_session: "لا توجد جلسة جارية.",
    back_to_review: "العودة إلى الأسئلة",
    errors: {
      dismiss: "إغلاق",
      refresh: "تحديث",
      attach_failed: "تعذّر على هذه الشاشة الاتصال كمعلّم.",
      unreachable: "تعذّر الوصول إلى الخادم. حدّث الصفحة للمحاولة مرة أخرى.",
      no_token: "لم يعد بإمكان علامة التبويب هذه التحكم في الاختبار. افتح Buzz من درسك لبدء جلسة جديدة.",
      taken_over: "يُدار هذا الاختبار الآن من شاشة أخرى.",
      stale_question: "تم تحديث Buzz أثناء هذا الاختبار، لذا لا يمكن لهذه الشاشة متابعته. أعد تحميل الصفحة لمتابعة الاختبار من حيث وصل الصف.",
      question_moved_on: "لقد انتقل الاختبار بالفعل إلى ما بعد هذا السؤال، لذا تأخرت هذه الشاشة. أعد تحميل الصفحة لمتابعة الاختبار من حيث وصل الصف.",
    },
    entry: {
      opening: "جارٍ فتح واجهة المعلّم…",
      token_title: "لا يمكن فتح رابط المعلّم هذا",
      token_body: "الرابط ينقصه مفتاح المعلّم أو انتهت صلاحيته. افتح Buzz من درسك لإنشاء جلسة جديدة.",
      not_found_title: "لم يُعثر على الجلسة",
      not_found_body: "جلسة الاختبار هذه لم تعد موجودة. أنشئ جلسة جديدة للمتابعة.",
      back: "العودة إلى البداية",
    },
    questions: {
      drag_aria: "اسحب لإعادة الترتيب",
      remove_aria: "احذف السؤال",
      empty: "لا توجد أسئلة متبقية في هذه الجلسة.",
      add: "إضافة",
      add_aria: "إضافة سؤال: {{text}}",
      add_all: "إضافة الكل",
      add_all_n: "إضافة جميع الأسئلة الـ {{count}}",
      more_zero: "لا توجد أسئلة أخرى في هذا الدرس",
      more_one: "{{count}} سؤال آخر في هذا الدرس",
      more_two: "سؤالان آخران في هذا الدرس",
      more_few: "{{count}} أسئلة أخرى في هذا الدرس",
      more_many: "{{count}} سؤالًا آخر في هذا الدرس",
      more_other: "{{count}} سؤال آخر في هذا الدرس",
      level_easy: "سهل",
      level_medium: "متوسط",
      level_hard: "صعب",
      multi: "متعدد",
    },
    lobby: {
      go_to: "اذهب إلى <strong>buzz.binogi.com</strong> وأدخل:",
      or_qr: "…أو امسح رمز QR",
      students_joined_of: "انضم {{joined}} من أصل {{expected}} طالب",
      students_joined_one: "انضم {{count}} طالب",
      students_joined_other: "انضم {{count}} طالب",
      waiting: "في انتظار انضمام الطلاب…",
      start_game: "ابدأ اللعبة",
      connected: "متصل",
      connecting: "جارٍ الاتصال…",
      copy_link: "نسخ الرابط",
      copy_link_copied: "تم النسخ!",
    },
    question: {
      header: "السؤال {{index}} من {{total}}",
      level: "المستوى {{level}}",
      none: "لا يوجد سؤال نشط.",
      answered: "أجاب",
      top_n: "أفضل {{count}}",
      answers_heading: "الإجابات",
      end_question: "إنهاء السؤال",
      next_question: "السؤال التالي",
      see_results: "عرض النتائج النهائية",
    },
    results: {
      heading: "النتائج النهائية",
      all_players: "جميع اللاعبين",
      end_session: "إنهاء الجلسة",
      new_session: "جلسة جديدة",
      none: "لا يوجد لاعبون في هذه الجلسة.",
    },
  },
  join: {
    code_label: "رمز اللعبة",
    name_label: "اسمك",
    name_placeholder: "اكتب اسمك",
    join_button: "انضم",
    joining: "جارٍ الانضمام…",
    checking: "جارٍ التحقق…",
    character_hint: "ستحصل على اسم شخصية ممتعة من Binogi عند انضمامك.",
    error_not_found:
      "هذا الرمز ليس لجلسة نشطة بعد. تحقّق منه مع معلّمك.",
    error_lookup_failed: "تعذّر العثور على الجلسة",
    error_code_required: "أدخل الرمز المكوّن من 6 أحرف.",
    error_name_required: "اكتب اسمك.",
  },
  play: {
    superseded: "أنت متصل في علامة تبويب أخرى — أغلقها لمواصلة اللعب هنا.",
    back_to_join: "العودة إلى الانضمام",
    no_round: "لا توجد بيانات للجولة.",
    not_joined: "لم تنضم إلى أي جلسة.",
    no_question: "لا يوجد سؤال نشط.",
    keep_awake_hint: "اضغط على الشاشة لإبقائها مضاءة",
    waiting: {
      you_are: "أنت",
      get_ready_named: "استعدّ يا {{name}}!",
      get_ready: "استعدّ للاختبار!",
      in_room_label: "الطلاب في الغرفة",
      in_room_one: "{{count}} طالب في الغرفة",
      in_room_other: "{{count}} طالب في الغرفة",
    },
    question: {
      progress: "{{index}} / {{total}}",
      answered: "تمت الإجابة!",
      times_up: "انتهى الوقت",
      submit: "إرسال",
      submit_n: "إرسال {{count}} إجابات",
    },
    between: {
      correct: "إجابة صحيحة!",
      wrong: "قريب جداً!",
      times_up: "انتهى الوقت",
      points_gained: "+{{count}} نقطة",
      your_score: "نقاطك",
      your_rank: "ترتيبك: {{rank}}",
      top_n: "أفضل {{count}}",
      waiting_next: "في انتظار السؤال التالي…",
    },
    finished: {
      heading: "شكراً للعبك Binogi Buzz!",
      your_final_rank: "ترتيبك النهائي",
      top_n: "أفضل {{count}}",
      none: "لا توجد نتائج لعرضها.",
    },
  },
  characters: {
    heading: "شخصيات Binogi",
    lead: "{{count}} طالب يحصلون على شخصية عند انضمامهم، بهذا الترتيب.",
  },
};
